export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = 'ไม่ได้เลือก %s';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s ไม่สามารถเว้นว่างไว้';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = 'จำเป็นต้องกรอก %s';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = 'กรอก %s ไม่ถูกต้อง';
                break;

            case 'opt-in':
                translation = 'กรุณาทำเครื่องหมายที่กล่องทำเครื่องหมายเพื่อดำเนินการต่อ';
                break;

            default:
                translation = 'ช่องนี้กรอกไม่ถูกต้อง';
                break;
        }

        return translation;
    }
}
